// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-A":"A_shp2-detail-A__eniHD"};